import { render } from "./Repositories.vue?vue&type=template&id=67ed265c"
import script from "./Repositories.vue?vue&type=script&lang=js"
export * from "./Repositories.vue?vue&type=script&lang=js"

import "./Repositories.vue?vue&type=style&index=0&id=67ed265c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__